module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px' + (_vm.ehAcessoPorLink ? ';margin-left: 0; background: white;' : ''))
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Edição de Sumário Executivo'
    }
  }), _vm._v(" "), (!_vm.ehAcessoPorLink) ? _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.sumarioCarregado.id) ? 'Novo Sumário' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' sumário executivo ID ' + _vm.sumarioCarregado.id))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [(_vm.salvaSumario.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    attrs: {
      "color": "primary",
      "type": "button",
      "title": '<h5>Ao clicar ele criará este sumério no sistema para uso. Então antes de fazê-lo verifique se não existe um sumário executivo desejado já criado</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cria novo sumário")]) : _vm._e(), _vm._v(" "), (_vm.salvaSumario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Criando Sumário ...")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [(_vm.salvaSumario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Salvando")]) : (_vm.salvaSumario.statusSalvamento === 'FEITO') ? _c('span', {
    staticClass: "button--moema success",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 10px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-verde) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Sumário salvo")]) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'lista-sumario-executivo'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando) && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimir()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir")]) : _vm._e()], 1), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', {
    attrs: {
      "stylple": "float: right; font-size: 14px;margin: 14px 10px 0 0"
    }
  }, [_vm._v("última atualização em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.ehAcessoPorLink) ? _c('section', {
    staticClass: "content",
    attrs: {
      "id": "sumario"
    }
  }, [_c('div', {
    staticClass: "row nao_imprimir"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('acao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Ação")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumarioCarregado.sumario.acao),
      expression: "sumarioCarregado.sumario.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "acao",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "acao",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Título do evento</h5>'
    },
    domProps: {
      "value": (_vm.sumarioCarregado.sumario.acao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sumarioCarregado.sumario, "acao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('acao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O título do evento (ação) a ser realizada é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    class: {
      'has-error': _vm.errors.first('data')
    },
    attrs: {
      "type": "date",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "name": "data",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "disabled-dates": {
        to: new Date(new Date().getTime() - 86400000)
      },
      "format": "dd/MM/yyyy",
      "title": '<h5>Data da ação</h5>'
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.data),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "data", $$v)
      },
      expression: "sumarioCarregado.sumario.data"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Horário")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumarioCarregado.sumario.inicio),
      expression: "sumarioCarregado.sumario.inicio"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "inicio",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Horário de Início</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sumarioCarregado.sumario, "inicio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.horarios), function(hora) {
    return _c('option', [_vm._v(_vm._s(hora))])
  }), 0)])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumarioCarregado.sumario.termino),
      expression: "sumarioCarregado.sumario.termino"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "termino",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Horário de término</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sumarioCarregado.sumario, "termino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.takeRight(_vm.horarios, (_vm.horarios.length - (_vm._.indexOf(_vm.horarios, _vm.sumarioCarregado.sumario.inicio))))), function(hora) {
    return _c('option', [_vm._v(_vm._s(hora))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Local")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumarioCarregado.sumario.local),
      expression: "sumarioCarregado.sumario.local"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "local",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "local",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Local onde será a ação</h5>'
    },
    domProps: {
      "value": (_vm.sumarioCarregado.sumario.local)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sumarioCarregado.sumario, "local", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('objeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Objeto")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumarioCarregado.sumario.objeto),
      expression: "sumarioCarregado.sumario.objeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "objeto",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "objeto",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>O objeto da ação</h5>'
    },
    domProps: {
      "value": (_vm.sumarioCarregado.sumario.objeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sumarioCarregado.sumario, "objeto", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('objeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O objeto da ação é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('finalidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Finalidade")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "col-md-10",
    attrs: {
      "title": '<h5>Finalidade da ação</h5>'
    }
  }, [_c('quill-editor', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "finalidade"
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.finalidade),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "finalidade", $$v)
      },
      expression: "sumarioCarregado.sumario.finalidade"
    }
  }), _vm._v(" "), (_vm.errors.first('finalidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" A Finalidade da ação é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('sinopse')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Sinopse")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "col-md-10",
    attrs: {
      "title": '<h5>Sinopse da ação</h5>'
    }
  }, [_c('quill-editor', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "sinopse"
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.sinopse),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "sinopse", $$v)
      },
      expression: "sumarioCarregado.sumario.sinopse"
    }
  }), _vm._v(" "), (_vm.errors.first('sinopse')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" A Sinopse da ação é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('participantes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Participantes / Interlocutores")]), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando)) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w20"
  }, [_vm._v("Participante")]), _vm._v(" "), _c('th', [_vm._v("Interlocutores")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Mostrar / Ocultar")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoParticipante()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.sumarioCarregado, 'sumario.participantes', [])).length > 0) ? _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sumarioCarregado.sumario.participantes = []
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "group": "lista_participantes",
      "disabled": _vm.ehVisualizacao,
      "tag": "tbody"
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.participantes),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "participantes", $$v)
      },
      expression: "sumarioCarregado.sumario.participantes"
    }
  }, 'draggable', {
    animation: 200,
    group: 'lista_participantes',
    disabled: false,
    ghostClass: 'ghost'
  }, false), _vm._l((_vm._.get(_vm.sumarioCarregado, 'sumario.participantes', [])), function(participante, idx) {
    return _c('tr', {
      staticClass: "handle_conteudo",
      staticStyle: {
        "cursor": "grab"
      }
    }, [_c('td', [_vm._v(_vm._s(participante.participante))]), _vm._v(" "), _c('td', [(_vm._.get(participante, 'interlocutores', []).length > 0) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "title": '<h5>' + _vm._.join(_vm._.map(participante.interlocutores, function(i) {
          return i.nome + ' (' + i.cargo + ')'
        }), ', ') + '</h5>'
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._.join(_vm._.map(_vm._.take(participante.interlocutores, 2), function(i) {
      return i.nome + ' (' + i.cargo + ')'
    }), ', ')) + "\n                                "), (_vm._.get(participante, 'interlocutores', []).length > 2) ? _c('span', [_vm._v(" ... mais " + _vm._s(participante.interlocutores.length - 2))]) : _vm._e()]) : _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Sem interlocutores")])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "text-left indicadores-cb-inline w10 text-center",
      attrs: {
        "title": '<h5>Mostra ou Oculta na impressão</h5>'
      }
    }, [(!_vm.ehVisualizacao) ? _c('i', {
      class: (_vm._.get(participante, 'mostrarParticipante', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
      on: {
        "click": function($event) {
          return _vm.mostrarOcultar(participante, 'mostrarParticipante')
        }
      }
    }) : _c('i', {
      class: (_vm._.get(participante, 'mostrarParticipante', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
      staticStyle: {
        "color": "var(--cor-fraca)"
      }
    })]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('td', {
      staticClass: "text-right w30 text-center"
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaParticipante(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplicaParticipante(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.removeParticipante(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('td', {
      staticClass: "text-right w30 text-center"
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaParticipante(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Detalhar")])], 1)])
  }), 0)], 1)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "well",
    style: ('background: ' + (!_vm._.isNull(_vm.interlocutorEditando) ? '#fff' : '#f1f6ff'))
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('participante')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Participante")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participanteEditando.participante),
      expression: "participanteEditando.participante"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "participante",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "participante",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Organização participante da ação</h5>'
    },
    domProps: {
      "value": (_vm.participanteEditando.participante)
    },
    on: {
      "keyup": function($event) {
        return _vm.buscaParticipantesJaCadastrados()
      },
      "blur": function($event) {
        return _vm.ocultaListaParticipantesJaCadastrados()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participanteEditando, "participante", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('participante')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Participante é obrigatório")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pesquisa.participantes),
      expression: "loading.pesquisa.participantes"
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "display": "block",
      "font-size": "20px",
      "color": "var(--cor-destaque)"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.pesquisa.participantes.mostrar && _vm.pesquisa.participantes.lista.length > 0) ? _c('div', {
    staticClass: "pesquisa_autocomplete"
  }, [_c('ul', _vm._l((_vm.pesquisa.participantes.lista), function(item) {
    return _c('li', {
      staticClass: "truncar",
      on: {
        "click": function($event) {
          return _vm.selecionaParticipanteJaCadastrado(item)
        }
      }
    }, [_vm._v(_vm._s(item.nomfor))])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Logomarca")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(!_vm._.has(_vm.participanteEditando, 'logomarca.ds_nome_arquivo')) ? _c('span', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "logomarca",
    attrs: {
      "type": "file",
      "name": "logomarca",
      "id": "logomarca",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando)
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]) : (_vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando)) ? _c('span', {
    staticStyle: {
      "color": "var(--cor-destaque)"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "16px",
      "max-width": "30px"
    },
    attrs: {
      "src": _vm.participanteEditando.logomarca.file
    }
  }), _vm._v("\n                              " + _vm._s(_vm.participanteEditando.logomarca.ds_nome_arquivo) + "\n                            ")]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticStyle: {
      "color": "var(--cor-destaque)",
      "cursor": "pointer"
    },
    attrs: {
      "title": '<h5>Clique para alterar a logomarca</h5>'
    },
    on: {
      "click": function($event) {
        _vm.participanteEditando.logomarca = {}
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "16px",
      "max-width": "30px"
    },
    attrs: {
      "src": _vm.participanteEditando.logomarca.file
    }
  }), _vm._v("\n                              " + _vm._s(_vm.participanteEditando.logomarca.ds_nome_arquivo) + " "), _c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Sobre\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarSobre', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarSobre')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarSobre', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('quill-editor', {
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "sobre"
    },
    model: {
      value: (_vm.participanteEditando.sobre),
      callback: function($$v) {
        _vm.$set(_vm.participanteEditando, "sobre", $$v)
      },
      expression: "participanteEditando.sobre"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Grupo/empresa(s)\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarGrupoEmpresa', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarGrupoEmpresa')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarGrupoEmpresa', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participanteEditando.grupo),
      expression: "participanteEditando.grupo"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "grupo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "grupo",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Grupo de empresas que faz parte se houver</h5>'
    },
    domProps: {
      "value": (_vm.participanteEditando.grupo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participanteEditando, "grupo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Segmento de atuação\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarSegmentoAtuacao', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarSegmentoAtuacao')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarSegmentoAtuacao', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participanteEditando.atuacao),
      expression: "participanteEditando.atuacao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "atuacao",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "atuacao",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Informar qual o segmento de atuação da organização se houver</h5>'
    },
    domProps: {
      "value": (_vm.participanteEditando.atuacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participanteEditando, "atuacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Histórico\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarHistorico', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarHistorico')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarHistorico', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('quill-editor', {
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.interlocutorEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "historico"
    },
    model: {
      value: (_vm.participanteEditando.historico),
      callback: function($$v) {
        _vm.$set(_vm.participanteEditando, "historico", $$v)
      },
      expression: "participanteEditando.historico"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Interlocutores\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarInterlocutores', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.participanteEditando, 'mostrarInterlocutores')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.participanteEditando, 'mostrarInterlocutores', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), (_vm._.isNull(_vm.interlocutorEditando)) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered",
    staticStyle: {
      "background": "white"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoInterlocutor()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.participanteEditando, 'interlocutores', [])).length > 0) ? _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.participanteEditando.interlocutores = []
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "group": "lista_interlocutores",
      "disabled": _vm.ehVisualizacao,
      "tag": "tbody"
    },
    model: {
      value: (_vm.participanteEditando.interlocutores),
      callback: function($$v) {
        _vm.$set(_vm.participanteEditando, "interlocutores", $$v)
      },
      expression: "participanteEditando.interlocutores"
    }
  }, 'draggable', {
    animation: 200,
    group: 'lista_interlocutores',
    disabled: false,
    ghostClass: 'ghost'
  }, false), _vm._l((_vm._.get(_vm.participanteEditando, 'interlocutores', [])), function(interlocutor, idx2) {
    return _c('tr', {
      staticClass: "handle_conteudo",
      staticStyle: {
        "cursor": "grab"
      }
    }, [_c('td', [_vm._v(_vm._s(interlocutor.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(interlocutor.cargo))]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('td', {
      staticClass: "text-right w30",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaInterlocutor(_vm.participanteEditando, idx2)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplicaInterlocutor(_vm.participanteEditando, idx2)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.removeInterlocutor(_vm.participanteEditando, idx2)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('td', {
      staticClass: "text-right w30",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaInterlocutor(_vm.participanteEditando, idx2)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Detalhar")])], 1)])
  }), 0)], 1)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "well",
    style: ('background: ' + (!_vm._.isNull(_vm.interlocutorEditando) ? '#f1f6ff' : '#fff'))
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interlocutorEditando.nome),
      expression: "interlocutorEditando.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Nome da pessoa que estará na ação representando o participante</h5>'
    },
    domProps: {
      "value": (_vm.interlocutorEditando.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interlocutorEditando, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Nome do interlocutor é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cargo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Cargo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interlocutorEditando.cargo),
      expression: "interlocutorEditando.cargo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "cargo",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cargo",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
      "title": '<h5>Cargo do interlocutor na organização participante</h5>'
    },
    domProps: {
      "value": (_vm.interlocutorEditando.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interlocutorEditando, "cargo", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Cargo do interlocutor é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interlocutorEditando.linkedin),
      expression: "interlocutorEditando.linkedin"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "linkedin",
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "name": "linkedin",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando),
      "placeholder": "https://www.linkedin.com/in/...",
      "title": '<h5>Url para o currículo digital no Linkedin, se houver</h5>'
    },
    domProps: {
      "value": (_vm.interlocutorEditando.linkedin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interlocutorEditando, "linkedin", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.okEdicaoInterlocutor(_vm.participanteEditando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelaEdicaoInterlocutor(_vm.participanteEditando)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando) ? 'Fechar' : 'Cancelar'))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm._.isNull(_vm.interlocutorEditando)) ? _c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.investimentoEditando)) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.okEdicaoParticipante()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelaEdicaoParticipante()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.investimentoEditando) ? 'Fechar' : 'Cancelar'))])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('investimentos')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Investimento socioambiental")]), _vm._v(" "), (_vm._.isNull(_vm.investimentoEditando)) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w20"
  }, [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Investimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Mostrar / Ocultar")]), _vm._v(" "), (_vm._.isNull(_vm.participanteEditando)) ? _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoInvestimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.ehVisualizacao && (_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sumarioCarregado.sumario.investimentos = []
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Excluir Todos")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "group": "lista_investimentos",
      "disabled": _vm.ehVisualizacao,
      "tag": "tbody"
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.investimentos),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "investimentos", $$v)
      },
      expression: "sumarioCarregado.sumario.investimentos"
    }
  }, 'draggable', {
    animation: 200,
    group: 'lista_investimentos',
    disabled: false,
    ghostClass: 'ghost'
  }, false), _vm._l((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])), function(investimento, idx) {
    return _c('tr', {
      staticClass: "handle_conteudo",
      staticStyle: {
        "cursor": "grab"
      }
    }, [_c('td', [_vm._v(_vm._s(investimento.origem))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]), _vm._v(" | "), _c('span', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]), _vm._v(" "), (investimento.valorParceiros > 0) ? _c('span', [_vm._v(" | Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "text-left indicadores-cb-inline w10 text-center",
      attrs: {
        "title": '<h5>Mostra ou Oculta na impressão</h5>'
      }
    }, [(!_vm.ehVisualizacao) ? _c('i', {
      class: (_vm._.get(investimento, 'mostrarInvestimento', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
      on: {
        "click": function($event) {
          return _vm.mostrarOcultar(investimento, 'mostrarInvestimento')
        }
      }
    }) : _c('i', {
      class: (_vm._.get(investimento, 'mostrarInvestimento', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
      staticStyle: {
        "color": "var(--cor-fraca)"
      }
    })]), _vm._v(" "), (!_vm.ehVisualizacao && _vm._.isNull(_vm.participanteEditando)) ? _c('td', {
      staticClass: "text-right w30 text-center"
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaInvestimento(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplicaInvestimento(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.removeInvestimento(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('td', {
      staticClass: "text-right w30 text-center"
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editaInvestimento(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Detalhar")])], 1)])
  }), 0)], 1)]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "background": "#f1f6ff"
    }
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('origem')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Origem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investimentoEditando.origem),
      expression: "investimentoEditando.origem"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "origem",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "origem",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Origem do investimento em geral é um título de projeto ou de uma articulação</h5>'
    },
    domProps: {
      "value": (_vm.investimentoEditando.origem)
    },
    on: {
      "keyup": function($event) {
        return _vm.buscaProjetosAprovados()
      },
      "blur": function($event) {
        return _vm.ocultaListaProjetosAprovados()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investimentoEditando, "origem", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pesquisa.projetos),
      expression: "loading.pesquisa.projetos"
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "display": "block",
      "font-size": "20px",
      "color": "var(--cor-destaque)"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.pesquisa.projetos.mostrar && _vm.pesquisa.projetos.lista.length > 0) ? _c('div', {
    staticClass: "pesquisa_autocomplete"
  }, [_c('ul', _vm._l((_vm.pesquisa.projetos.lista), function(item) {
    return _c('li', {
      staticClass: "truncar",
      on: {
        "click": function($event) {
          return _vm.selecionaProjetosAprovados(item)
        }
      }
    }, [_vm._v(_vm._s(item.nomprj))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Pbjeto é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Próprios (Fundação BB)\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorFBB', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorFBB')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorFBB', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.investimentoEditando.valorFBB),
      callback: function($$v) {
        _vm.$set(_vm.investimentoEditando, "valorFBB", $$v)
      },
      expression: "investimentoEditando.valorFBB"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Contrapartida\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorContrapartida', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorContrapartida')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorContrapartida', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorContrapartida",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.investimentoEditando.valorContrapartida),
      callback: function($$v) {
        _vm.$set(_vm.investimentoEditando, "valorContrapartida", $$v)
      },
      expression: "investimentoEditando.valorContrapartida"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Parceiros Estratégicos\n                            "), (!_vm.ehVisualizacao) ? _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorParceiros', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash') + ' mostrar_ocultar_impressao',
    on: {
      "click": function($event) {
        return _vm.mostrarOcultar(_vm.investimentoEditando, 'mostrarValorParceiros')
      }
    }
  }) : _c('i', {
    class: (_vm._.get(_vm.investimentoEditando, 'mostrarValorParceiros', true) ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorParceiros",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.investimentoEditando.valorParceiros),
      callback: function($$v) {
        _vm.$set(_vm.investimentoEditando, "valorParceiros", $$v)
      },
      expression: "investimentoEditando.valorParceiros"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "col-md-10",
    attrs: {
      "title": '<h5>Caso haja alguma observação pertinente ao investimento</h5>'
    }
  }, [_c('quill-editor', {
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "observacao"
    },
    model: {
      value: (_vm.investimentoEditando.observacao),
      callback: function($$v) {
        _vm.$set(_vm.investimentoEditando, "observacao", $$v)
      },
      expression: "investimentoEditando.observacao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && _vm._.isNull(_vm.participanteEditando)) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.okEdicaoInvestimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelaEdicaoInvestimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) ? 'Fechar' : 'Cancelar'))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Produto")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "col-md-10",
    attrs: {
      "title": '<h5>Se houver um produto resultado da ação, então gere descritivo sobre ele</h5>'
    }
  }, [_c('quill-editor', {
    ref: "refQuillEditor",
    attrs: {
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.participanteEditando) || !_vm._.isNull(_vm.investimentoEditando),
      "options": _vm.quillOptionsCompleto,
      "name": "produto"
    },
    model: {
      value: (_vm.sumarioCarregado.sumario.produto),
      callback: function($$v) {
        _vm.$set(_vm.sumarioCarregado.sumario, "produto", $$v)
      },
      expression: "sumarioCarregado.sumario.produto"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row imprimir",
    staticStyle: {
      "font-family": "'BancoDoBrasil Textos'"
    },
    attrs: {
      "id": "sumario_impresso"
    }
  }, [_c('div', {
    staticClass: "cabecalho_sumario_executivo"
  }, [_c('span', [_vm._v("Sumário Executivo")]), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [_vm._v("última atualização em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sumario_criticidade"
  }, [_vm._v("#interna")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "titulo_sumario_executivo",
    staticStyle: {
      "font-family": "'BancoDoBrasil Titulos ExtraBold'"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.sumarioCarregado.sumario.acao) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Ação: " + _vm._s(_vm.sumarioCarregado.sumario.acao))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Data/horário:")]), _vm._v(" " + _vm._s(_vm.moment(_vm.sumarioCarregado.sumario.data).add(1, 'day').format('DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.inicio, "HH:mm")) + " as " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.termino, "HH:mm"))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.local) + "\n        ")]), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Participantes/Interlocutores")]), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
    return (_vm._.get(participante, 'mostrarParticipante', true)) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "margin-bottom": "20px"
      }
    }, [_c('span', [_c('span', {
      staticClass: "participante_sumario_executivo text-bold"
    }, [_vm._v(_vm._s(participante.participante))]), _c('br'), _vm._v(" "), _vm._l((participante.interlocutores), function(interlocutor) {
      return (_vm._.get(participante, 'mostrarInterlocutores', true)) ? _c('span', [_c('span', {
        staticClass: "interlocutor_sumario_executivo"
      }, [_vm._v(_vm._s(interlocutor.nome) + " - " + _vm._s(interlocutor.cargo))]), _c('br')]) : _vm._e()
    })], 2), _vm._v(" "), (_vm._.has(participante, 'logomarca.file')) ? _c('span', [_c('img', {
      staticStyle: {
        "max-height": "70px"
      },
      attrs: {
        "src": participante.logomarca.file
      }
    })]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Objeto:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.objeto) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Finalidade:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.finalidade)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Sinopse:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.sinopse)
    }
  })]), _vm._v(" "), ((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('span', [_c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Investimento socioambiental:")]), _c('br'), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.investimentos), function(investimento) {
    return (_vm._.get(investimento, 'mostrarInvestimento', true)) ? _c('span', [_c('span', {
      staticClass: "investimento_sumario_executivo"
    }, [_vm._v(_vm._s(investimento.origem))]), _c('br'), _vm._v(" "), _c('ul', [(_vm._.get(investimento, 'mostrarValorFBB', true)) ? _c('li', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorContrapartida', true)) ? _c('li', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorParceiros', true)) ? _c('li', [_vm._v("Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm._.get(investimento, 'observacao')) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.get(investimento, 'observacao', ''))
      }
    }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('span', _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
    return (_vm._.get(participante, 'mostrarParticipante', true) && (_vm._.get(participante, 'mostrarSobre', true) || _vm._.get(participante, 'mostrarGrupoEmpresa', true) || _vm._.get(participante, 'mostrarSegmentoAtuacao', true) || _vm._.get(participante, 'mostrarHistorico', true))) ? _c('div', [_c('div', {
      staticClass: "titulo_sumario_executivo"
    }, [_vm._v("\n              Sobre " + _vm._s(participante.participante) + "\n            ")]), _vm._v(" "), (_vm._.get(participante, 'mostrarSobre', true)) ? _c('div', {
      staticClass: "bloco_sumario_executivo"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(participante.sobre)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bloco_sumario_executivo"
    }, [_c('table', {
      staticClass: "table table-condensed table-bordered table-striped"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [(_vm._.get(participante, 'mostrarGrupoEmpresa', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Grupo/empresa(s):")]), _vm._v(" " + _vm._s(participante.grupo))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarSegmentoAtuacao', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Segmento de atuação:")]), _vm._v(" " + _vm._s(participante.atuacao))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarHistorico', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Histórico/Destaques mercadológicos e institucionais/Estratégia do grupo:")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(participante.historico)
      }
    })])]) : _vm._e()])])])]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioCarregado, 'sumario.produto') && !_vm._.isEmpty(_vm.sumarioCarregado.sumario.produto)) ? _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Sobre o produto")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.produto)
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehAcessoPorLink) ? _c('section', {
    staticClass: "content",
    attrs: {
      "id": "sumario_acesso_externo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cabecalho_sumario_executivo"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Sumário Executivo")]), _c('br'), _vm._v(" "), (!_vm._.isNull(_vm.sumarioCarregado.id)) ? _c('span', [_vm._v("atualizado em " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.updated_at, "DD/MM/YYYY HH:mm:ss")))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sumario_criticidade"
  }, [_vm._v("#interna")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "titulo_sumario_executivo"
  }, [_vm._v(_vm._s(_vm.sumarioCarregado.sumario.acao))]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Ação: " + _vm._s(_vm.sumarioCarregado.sumario.acao))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Data/horário:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.data, "L")) + " - " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.inicio, "HH:mm")) + " as " + _vm._s(_vm._f("moment")(_vm.sumarioCarregado.sumario.termino, "HH:mm"))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Local:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.local) + "\n        ")]), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Participantes/Interlocutores")]), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
    return (_vm._.get(participante, 'mostrarParticipante', true)) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "margin-bottom": "20px"
      }
    }, [_c('span', [_c('span', {
      staticClass: "participante_sumario_executivo text-bold"
    }, [_vm._v(_vm._s(participante.participante))]), _c('br'), _vm._v(" "), _vm._l((participante.interlocutores), function(interlocutor) {
      return (_vm._.get(participante, 'mostrarInterlocutores', true)) ? _c('span', [(_vm._.has(interlocutor, 'linkedin') && !_vm._.isEmpty(interlocutor.linkedin)) ? _c('span', {
        staticClass: "interlocutor_sumario_executivo"
      }, [_c('a', {
        attrs: {
          "href": interlocutor.linkedin
        }
      }, [_vm._v(" " + _vm._s(interlocutor.nome) + " "), _c('span', {
        staticStyle: {
          "font-style": "italic"
        }
      }, [_vm._v("(" + _vm._s(interlocutor.cargo) + ") "), _c('i', {
        staticClass: "fa fa-linkedin-square"
      })])])]) : _c('span', {
        staticClass: "interlocutor_sumario_executivo"
      }, [_vm._v(_vm._s(interlocutor.nome) + "  "), _c('span', {
        staticStyle: {
          "font-style": "italic"
        }
      }, [_vm._v("(" + _vm._s(interlocutor.cargo) + ")")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()
    })], 2), _vm._v(" "), (_vm._.has(participante, 'logomarca.file')) ? _c('span', [_c('img', {
      staticStyle: {
        "max-height": "70px"
      },
      attrs: {
        "src": participante.logomarca.file
      }
    })]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titulo_sumario_executivo"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Objeto:")]), _vm._v(" " + _vm._s(_vm.sumarioCarregado.sumario.objeto))]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Finalidade:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.finalidade)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Sinopse:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.sinopse)
    }
  })]), _vm._v(" "), ((_vm._.get(_vm.sumarioCarregado, 'sumario.investimentos', [])).length > 0) ? _c('span', [_c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Investimento socioambiental:")]), _c('br'), _vm._v(" "), _vm._l((_vm.sumarioCarregado.sumario.investimentos), function(investimento) {
    return (_vm._.get(investimento, 'mostrarInvestimento', true)) ? _c('span', [_c('span', {
      staticClass: "investimento_sumario_executivo text-bold"
    }, [_vm._v(_vm._s(investimento.origem))]), _c('br'), _vm._v(" "), _c('ul', [(_vm._.get(investimento, 'mostrarValorFBB', true)) ? _c('li', [_vm._v("Próprios: " + _vm._s(_vm._f("real")(investimento.valorFBB)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorContrapartida', true)) ? _c('li', [_vm._v("Contrapartida: " + _vm._s(_vm._f("real")(investimento.valorContrapartida)))]) : _vm._e(), _vm._v(" "), (_vm._.get(investimento, 'mostrarValorParceiros', true)) ? _c('li', [_vm._v("Terceiros: " + _vm._s(_vm._f("real")(investimento.valorParceiros)))]) : _vm._e()]), _c('br'), _vm._v(" "), (_vm._.get(investimento, 'observacao')) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.get(investimento, 'observacao', ''))
      }
    }) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sumarioCarregado.sumario.participantes.length > 0) ? _c('span', _vm._l((_vm.sumarioCarregado.sumario.participantes), function(participante) {
    return (_vm._.get(participante, 'mostrarParticipante', true) && (_vm._.get(participante, 'mostrarSobre', true) || _vm._.get(participante, 'mostrarGrupoEmpresa', true) || _vm._.get(participante, 'mostrarSegmentoAtuacao', true) || _vm._.get(participante, 'mostrarHistorico', true))) ? _c('div', [_c('div', {
      staticClass: "titulo_sumario_executivo"
    }, [_vm._v("Sobre " + _vm._s(participante.participante))]), _vm._v(" "), (_vm._.get(participante, 'mostrarSobre', true)) ? _c('div', {
      staticClass: "bloco_sumario_executivo"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(participante.sobre)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bloco_sumario_executivo"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [(_vm._.get(participante, 'mostrarGrupoEmpresa', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Grupo/empresa(s):")]), _vm._v(" " + _vm._s(participante.grupo))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarSegmentoAtuacao', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Segmento de atuação:")]), _vm._v(" " + _vm._s(participante.atuacao))])]) : _vm._e(), _vm._v(" "), (_vm._.get(participante, 'mostrarHistorico', true)) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Histórico/Destaques mercadológicos e institucionais/Estratégia do grupo:")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(participante.historico)
      }
    })])]) : _vm._e()])])])]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioCarregado, 'sumario.produto') && !_vm._.isEmpty(_vm.sumarioCarregado.sumario.produto)) ? _c('div', {
    staticClass: "bloco_sumario_executivo"
  }, [_c('strong', [_vm._v("Sobre o produto")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumarioCarregado.sumario.produto)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "10px",
      "font-style": "italic",
      "border-top": "1px solid silver"
    }
  }, [_vm._v("Término do Sumário Executivo")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Linkedin "), _c('i', {
    staticClass: "fa fa-linkedin-square"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Visão Geral")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Visão Geral")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdd82824!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/sumarioExecutivo/EditaSumarioExecutivo.vue
// module id = 2069
// module chunks = 1